module.exports = __webpack_public_path__ + "img/caja-arequipa.129ba577.svg";